/** Dynamic import of the signed-in navigation chunk (sidebar, role menus, notification bell). */
export const loadAuthenticatedNavigation = () => import('./AuthenticatedNavigation');
